
import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useGlobalStore } from "../utils/global";

// Utility to inject GTM script and noscript
function injectGTM() {
  // Inject script into <head>
  if (!document.getElementById("gtm-script")) {
    const script = document.createElement("script");
    script.id = "gtm-script";
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-TR8RGMJ3');`;
    document.head.appendChild(script);
  }
  // Inject noscript into <body>
  if (!document.getElementById("gtm-noscript")) {
    const noscript = document.createElement("noscript");
    noscript.id = "gtm-noscript";
    noscript.innerHTML = `<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-TR8RGMJ3\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>`;
    document.body.insertBefore(noscript, document.body.firstChild);
  }
}
// Utility to remove GTM script and noscript
function removeGTM() {
  const script = document.getElementById("gtm-script");
  if (script) {
    script.remove();
  }
  const noscript = document.getElementById("gtm-noscript");
  if (noscript) {
    noscript.remove();
  }
  // Optionally clear dataLayer entries if present
  try {
    if ((window as any).dataLayer && Array.isArray((window as any).dataLayer)) {
      (window as any).dataLayer.length = 0;
    }
  } catch (e) {
    // ignore
  }
}


const PrivateRoute = () => {
  const {user} = useGlobalStore();
  useEffect(() => {
    if (user) {
      injectGTM();
    } else {
      removeGTM();
    }
    return () => {
      // Ensure GTM is removed when PrivateRoute unmounts
      removeGTM();
    };
  }, [user]);
  return user ? <Outlet /> : <Navigate to="/login" replace />;
}

export default PrivateRoute;
